import { keys, reduce, isNil } from 'lodash';
import { Validations, Helpers } from '@utils/helpers';
import { IError } from '@utils/useForm';
import { BasicDetailsForm } from '@models/SIO/BasicDetails.model';

export const validate = (values: BasicDetailsForm) => {
  const fields = keys(values);
  const errors: any = reduce(fields, (result, field: string) => {
    return { ...result, [field]: validateField(values, field) };
  }, {});
  return errors;
}

export const validateField = (values: any, name: string) => {
  const value = values[name];
  let error: IError | undefined = { isValid: true };
  switch(name) {
    case 'dob':
      const minAge = 17, maxAge = 65;
      const { day, month, year } = value;
      const stringDate = `${month}/${day}/${year}`;
      if (isNil(year) && ( isNil(day) || isNil(month))) {
        error = { isValid: false };
      } else {
        if (Validations.isValidDayOfBirth(stringDate) && Number(year) > 10) {
          const refDay = new Date(stringDate);
          const aged = Helpers.getAge(refDay);
          const isInRange: number = Validations.isInRange(aged, minAge, maxAge);
          if (isInRange !== 0) {
            error = { 
              isValid: false,
              message: `Only applicable for ${isInRange === - 1 ? `${minAge} Age Next Birthday and above` : `${maxAge} Age Next Birthday and below`}`
            };
          }
        } else {
          error = { isValid: false, message: "Please enter a valid date" };
        }
      }
      break
    case 'gender':
    case 'smoker':
    case 'occupationName':
    case 'nationalityCode':
      if (isNil(value)) {
        error = { isValid: false }
      }
      break;
    case 'required1':
    case 'required2':
    case 'required3':
    case 'required4':
      if (!value) {
        error = { isValid: false }
      }
      break;
     
  }
  return error;
}
